// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Collapse from "@mui/material/Collapse";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";

// Custom styles for the sidenavItem
import {
  item,
  itemIcon,
  itemText,
  itemIconBox,
} from "examples/Sidenav/styles/sidenavItem";

// Argon Dashboard 2 MUI context
import { useArgonController } from "context";

function SidenavItem({ icon, name, active = false, open = false, nested, ...rest }) {
  const [controller] = useArgonController();
  const { miniSidenav, darkSidenav, sidenavColor } = controller;

  return (
    <>
      <ListItem component="li" disablePadding>
        <ArgonBox
          {...rest}
          sx={(theme) => {
            // Create a fallback color if theme.palette[sidenavColor] or theme.palette.info is undefined
            const defaultColor = {
              main: "#49a3f1", // Default info color
              state: "#2196f3", // Default info hover state
            };
            
            // First try to use the dynamic sidenavColor, fall back to "info", then to defaultColor
            const resolvedColor = (theme.palette && theme.palette[sidenavColor]) || 
                                 (theme.palette && theme.palette.info) || 
                                 defaultColor;
            

            return item(theme, {
              active,
              darkSidenav,
              sidenavColor,
              miniSidenav,
              resolvedColor,
            });
          }}
        >
          <ListItemIcon
            sx={(theme) =>
              itemIconBox(theme, {
                active,
                darkSidenav,
                sidenavColor,
              })
            }
          >
            {typeof icon === "string" ? (
              <Icon sx={(theme) => itemIcon(theme, { active })}>{icon}</Icon>
            ) : (
              icon
            )}
          </ListItemIcon>

          <ListItemText
            primary={name}
            sx={(theme) =>
              itemText(theme, {
                miniSidenav,
                darkSidenav,
                active,
              })
            }
          />
        </ArgonBox>
      </ListItem>
    </>
  );
}


// Typechecking props for the SidenavItem
SidenavItem.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
  open: PropTypes.bool,
  nested: PropTypes.bool,
};

export default SidenavItem;